import React from 'react';
import * as rmd from 'material-ui';
import RCore from 'RCore';
import cfg from 'cfg';

class TeamTournamentsPicker extends React.Component {
    static defaultProps = {
        singleOption: false,
    };

    constructor(props, context) {
        super(props, context);

        const tournamentKey = props.propsMap && props.propsMap.ttIds ? props.propsMap.ttIds : 'ttIds';
        const seasonKey = props.propsMap && props.propsMap.seasonIds ? props.propsMap.seasonIds : 'seasonIds';

        try {
            const tournaments = this.isArrayHandler(props[tournamentKey]);

            this.state = {
                teamId: parseInt(props.teamId, 10),
                tournamentKey,
                seasonKey,
                mainTournamentId: null,
                tournamentTeamIds: [],
                tournamentsTeam: [],
                seasonsTeamIds: [],
                ttIds: tournaments,
                seasonIds: this.isArrayHandler(props[seasonKey]),
                allTournaments: tournaments.length === 0,
            };
        } catch (e) {
            console.error(e);
        }
    }

    componentDidMount() {
        this.loadTournaments();
    }

    componentWillReceiveProps({ teamId }) {
        if (this.state.teamId !== teamId) {
            this.setState(
                {
                    teamId: teamId,
                    mainTournamentId: null,
                    tournamentTeamIds: [],
                    tournamentsTeam: [],
                    seasonsTeamIds: [],
                    allTournaments: true,
                    ttIds: [],
                    seasonIds: [],
                },
                () => {
                    this.loadTournaments();
                },
            );
        }
    }

    isArrayHandler(isArr) {
        if (Array.isArray(isArr)) return isArr;
        else return isArr ? [isArr] : [];
    }

    onChangeProp() {
        const { onChange, singleOption } = this.props;

        const {
            tournamentKey,
            seasonKey,
            allTournaments,
            ttIds,
            seasonIds,
            tournamentTeamIds,
            seasonsTeamIds,
        } = this.state;

        if (singleOption) {
            if (allTournaments) {
                onChange(
                    {
                        [tournamentKey]: null,
                        [seasonKey]: null,
                    },
                    null,
                );
            } else {
                onChange({
                    [tournamentKey]: ttIds.length ? ttIds[0] : null,
                    [seasonKey]: seasonIds.length ? seasonIds[0] : null,
                });
            }
        } else if (allTournaments) {
            // onChange(
            //     {
            //         [tournamentKey]: null,
            //         [seasonKey]: null
            //     },
            //     null
            // );
            onChange(
                {
                    [tournamentKey]: tournamentTeamIds.filter(id => id !== 489),
                    [seasonKey]: seasonsTeamIds,
                },
                null,
            );
        } else {
            onChange({
                [tournamentKey]: ttIds.length ? ttIds : null,
                [seasonKey]: seasonIds.length ? seasonIds : null,
            });
        }
    }

    loadTournaments() {
        const { teamId, ttIds } = this.state;

        if (!teamId) return RCore.promiseProps({});

        return RCore.promiseProps({
            team: fetch(`${cfg.apis.ss2}/teams/${teamId}`).then(response => response.json()),
        })
            .then(res =>
                RCore.promiseProps({
                    ...res,
                    tournamentTeamIds: res.team && res.team.tournamentTemplateId,
                    mainTournamentId: res.team && res.team.mainTournamentId,
                }),
            )
            .then(res =>
                RCore.promiseProps({
                    ...res,
                    allTournaments: ttIds.length === 0,
                    ttIds: ttIds.length === 0 ? this.isArrayHandler(res.mainTournamentId) : ttIds,
                    tournamentsTeam: Promise.all(
                        res.tournamentTeamIds.map(id =>
                            fetch(`${cfg.apis.ss2}/tournaments/${id}`).then(response => response.json()),
                        ),
                    ).then(res => res.filter(tournament => tournament.currentSeason)),
                }),
            )
            .then(res => {
                const tournamentsTeam = res.tournamentsTeam.filter(tournament => tournament.currentSeason);

                return RCore.promiseProps({
                    ...res,
                    seasonsTeamIds: tournamentsTeam.reduce((acc, curr) => {
                        return curr.id !== 489 ? [...acc, curr.currentSeason.id] : acc;
                    }, []),
                    seasonIds: tournamentsTeam.reduce((acc, curr) => {
                        if (res.ttIds.indexOf(curr.id) !== -1) {
                            return [...acc, curr.currentSeason.id];
                        } else {
                            return [...acc];
                        }
                    }, []),
                });
            })
            .then(res => {
                this.setState(res, () => {
                    this.onChangeProp();
                });
            })
            .catch(e => {
                console.error(e);
            });
    }

    handleTournamentCheck = (tId, e, val) => {
        const { singleOption } = this.props;
        const ttIds = val
            ? [...(singleOption ? [] : this.state.ttIds), tId]
            : this.state.ttIds.filter(id => id !== tId);
        const seasonIds = this.state.tournamentsTeam.reduce((acc, curr) => {
            if (ttIds.indexOf(curr.id) !== -1) return [...acc, curr.currentSeason.id];
            else return [...acc];
        }, []);
        let allTournaments = false;

        if (ttIds.length === this.state.tournamentTeamIds.length || !ttIds.length) allTournaments = true;

        this.setState(
            {
                ttIds,
                seasonIds,
                allTournaments,
            },
            () => {
                this.onChangeProp();
            },
        );
    };

    checkedHandler(id) {
        const { allTournaments, ttIds, tournamentTeamIds } = this.state;

        return allTournaments ? tournamentTeamIds.indexOf(id) !== -1 : ttIds.indexOf(id) !== -1;
    }

    render() {
        const { tournamentsTeam, allTournaments, tournamentTeamIds, seasonsTeamIds } = this.state;

        return (
            <div>
                <rmd.Toggle
                    label="All tournaments"
                    toggled={allTournaments}
                    onToggle={(e, value) => {
                        if (allTournaments && !value) {
                            this.setState(
                                {
                                    allTournaments: value,
                                    ttIds: [tournamentTeamIds[0]],
                                    seasonIds: [seasonsTeamIds[0]],
                                },
                                () => {
                                    this.onChangeProp();
                                },
                            );
                        } else {
                            this.setState(
                                {
                                    allTournaments: value,
                                },
                                () => {
                                    this.onChangeProp();
                                },
                            );
                        }
                    }}
                    style={{ marginBottom: '16px', marginTop: '16px' }}
                />
                {tournamentsTeam.map(t => {
                    if (t.id === 489) return;

                    return (
                        <rmd.Checkbox
                            key={t.id}
                            disabled={allTournaments}
                            checked={this.checkedHandler(t.id)}
                            onCheck={this.handleTournamentCheck.bind(this, t.id)}
                            label={`${t.name}  `}
                        />
                    );
                })}
            </div>
        );
    }
}

export default TeamTournamentsPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TeamTournamentsPicker.js
 **/